import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import instalarEnterComoTab from './util/enterComoTab';

// Enter funciona como Tab nos campos de edição
instalarEnterComoTab();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// PWA: registra o service worker (somente no build de produção)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    // eloOficina (/oficina) tem PWA próprio, com funcionamento offline
    if (/^\/oficina(\/|$)/i.test(window.location.pathname)) {
      navigator.serviceWorker.register('/oficina/service-worker.js', { scope: '/oficina/' }).catch(() => {});
      return;
    }
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch(() => {});
  });
}
